import React from 'react';

type Specialist = {
  name: string;
  iconUrl: string;
  onClick?: () => void; // tambahkan ini

};

const SpecialistCard = ({ name, iconUrl, onClick }: Specialist) => {
  return (
    <div
      onClick={onClick}
      className="flex flex-col items-center bg-white rounded-xl p-4 shadow hover:shadow-md transition cursor-pointer h-full"
    >
      {/* Icon */}
      <div className="w-20 h-20 rounded-full bg-gray-50 flex items-center justify-center mb-2 shrink-0">
        <img
          src={iconUrl}
          alt={name}
          className="w-10 h-10 object-contain"
          onError={(e) => {
            e.currentTarget.src =
              'https://m.linksehat.com/assets/img/users/dummy.jpg';
          }}
        />
      </div>

      {/* Text */}
      <div className="px-2 w-full">
        <p
          className="text-sm text-gray-700 font-medium text-center leading-snug
                    line-clamp-2 break-words"
        >
          {name}
        </p>
      </div>
    </div>

  
  );
};

export default SpecialistCard;
